import { useState } from "react";

export default function SafetySection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      q: "Is Sugargoo Legit?",
      a: "Yes, Sugargoo is a legitimate and well-established shopping agent that has been operating for several years. The company maintains secure warehouse facilities, employs a professional QC team, and processes thousands of successful international orders every month. They use secure payment gateways with buyer protection policies in place. However, as with any international shopping service, users should understand the risks: items may occasionally differ from listing photos, shipping delays can occur, and customs fees may apply depending on your destination country. Always review QC photos carefully and communicate with your agent before finalizing shipment.",
    },
    {
      q: "How Does the Sugargoo Warehouse System Work?",
      a: "When you purchase items through Sugargoo, they are first shipped domestically to Sugargoo's warehouse facility. Upon arrival, warehouse staff inspect and photograph each item. These QC (Quality Control) photos are uploaded to your account so you can verify the condition, color, sizing, and overall quality. The warehouse provides free storage for a limited period — typically 30 to 180 days depending on your account status. You can accumulate multiple items from different sellers and ship them together in one international package to save on shipping costs.",
    },
    {
      q: "Are My Payments Safe on Sugargoo?",
      a: "Sugargoo uses standard payment processing with multiple secure payment methods including PayPal, credit/debit cards, and various regional payment options. PayPal provides an additional layer of buyer protection for disputes. Sugargoo does not store your payment card details on their servers. For added security, always ensure you are on the official Sugargoo website and avoid sharing your account credentials with third parties. The platform's reputation is built on consistent, reliable service — but sensible precautions like using PayPal for larger first orders are always recommended.",
    },
    {
      q: "What Happens If an Item Arrives Damaged or Is Wrong?",
      a: "This is where the QC photo system becomes invaluable. Before your items leave the warehouse, you review detailed photos showing the actual product you received. If something looks wrong — wrong size, damaged, incorrect color, logo issues — you can request a return or exchange with the seller before international shipping. Once you approve the QC photos and the package ships internationally, returns become more complicated and expensive. Always take advantage of the QC review period to catch issues early.",
    },
    {
      q: "How Do Sugargoo Spreadsheets Help Me Save Money?",
      a: "Sugargoo spreadsheets aggregate product information from multiple sellers, allowing you to compare prices, shipping fees, and seller ratings at a glance. Instead of manually searching through hundreds of individual listings, you can identify the best-priced option in seconds. Spreadsheets also include coupon codes, seasonal promotions, and bundle deals that individual listings often do not display. Regular spreadsheet users report saving 15-30% compared to unsystematic browsing — that adds up significantly on larger hauls.",
    },
    {
      q: "What Countries Does Sugargoo Ship To?",
      a: "Sugargoo ships to most countries worldwide, including the United States, United Kingdom, Canada, Australia, Germany, France, Japan, South Korea, and many more. Shipping costs and delivery times vary significantly based on destination, package weight, and chosen shipping method. Major destinations like the USA and UK typically have the most competitive rates and fastest delivery options. Use the shipping calculator within your Sugargoo account to get accurate estimates before committing to a purchase.",
    },
  ];

  return (
    <section className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold uppercase tracking-wider mb-4">
            Safety &amp; Trust
          </span>
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950 mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-foreground-600 leading-relaxed">
            Everything you need to know about Sugargoo — safety, warehouse operations, payment security, and how spreadsheets maximize your savings.
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="rounded-lg border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-background-100 transition-colors cursor-pointer"
              >
                <span className="text-sm md:text-base font-semibold text-foreground-800 pr-4">
                  {faq.q}
                </span>
                <i
                  className={`ri-arrow-down-s-line text-lg text-foreground-400 flex-shrink-0 transition-transform duration-200 ${
                    openIndex === i ? "rotate-180" : ""
                  }`}
                ></i>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-4">
                  <div className="pt-1 border-t border-background-200/40">
                    <p className="text-sm text-foreground-600 leading-relaxed pt-3">
                      {faq.a}
                    </p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}